var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"w-full flex flex-col"},[_c('Header',{directives:[{name:"show",rawName:"v-show",value:(!_vm.$route.meta.noHeader),expression:"!$route.meta.noHeader"}]}),_c('div',{class:!_vm.$route.meta.noHeader?'contmt':'',staticStyle:{"background-color":"#f7f3fc"}},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }